<template>
      <div> 
            <barra-navegacao :visiblebar="true" :visiblebutton="true"/>
            <b-card                            
                class="modern-nav-card">
              <div>
                <strong>Bloco: </strong> {{local.bloco.descricao}} |
                <strong>Andar: </strong> {{local.andar.descricao}} |
                <strong v-if="local.corredor">Corredor: </strong> <span v-if="local.corredor">{{local.corredor.descricao}} |</span>
                <strong>Sala: </strong> {{local.sala.descricao}} {{local.sala.numeroSala}}
              </div>
                
              <b-col>
                  <hr>
                    <h4 style="color: red">Selecione somente os itens com problema</h4>
                  <hr>
              </b-col>
              <b-col cols="12" style="margin-top: 20px; text-align: left; " class="form-inline">
                <b-col lg="4" md="6" sm="12" v-for="(problema,index) in problemas" :key="index" style="padding: 10px">
                  <toggle-button
                      style="margin-right: 10px"
                      :value="problema.isEnable"
                      @change="addProblemaOcorrencia(problema)"
                      :color="{checked: '#fabf3a'}"
                      :width="70"
                  />
                  {{ problema.descricao }}
                </b-col>
              </b-col>
              <b-col cols="12" style="margin-top: 20px;" class="form-inline">
                <b-button :disabled="!enableFinalize" block style="background-color: #303f9f"
                          @click="abrirOcorrencia()">
                  <b-icon icon="cloud-upload-fill"></b-icon>
                  Abrir Ocorrência
                </b-button>
              </b-col>
               
            </b-card>
      </div>
</template>

<script>
import BarraNavegacao from '../components/BarraNavegacao.vue';

export default {
  components: {BarraNavegacao},
  data() {
    return {
      local: '',
      idLocal: 0,
      setores: [],
      setorSelect: 0,
      problemas: [],
      enableFinalize: false
    }
  },

  created() {
    this.tipoLocal = 'andar_sala';
    let paramId = this.$route.params.idAndarSala;
    if (typeof paramId === 'string' && paramId.startsWith('c_')) {
      this.idLocal = paramId.substring(2);
      this.tipoLocal = 'corredor_sala';
    } else {
      this.idLocal = paramId;
    }
    this.getLocal();
    this.listaProblemas();
  },

  methods: {
    getLocal() {
      this.$http
          .get("/sala/local?id_local=" + this.idLocal + "&tipo_local=" + this.tipoLocal)
          .then((res) => {
            this.local = res.data;
          });

    },

    listarSetores() {
      this.$http
          .get("/setor")
          .then((res) => {
            this.setores = res.data;
          });

    },

    listaProblemas() {
      this.$http
          .get("/problema")
          .then((res) => {
            this.problemas = res.data;
          });
    },

    addProblemaOcorrencia(problema) {
      this.problemas.map((item) => {
        if (item.idProblema === problema.idProblema) {
          item.isEnable = !item.isEnable;
        }
      });

      this.verificaProblemaAtivo();
    },

    verificaProblemaAtivo() {
      this.enableFinalize = this.problemas.filter((problema) => problema.isEnable).length > 0;
    },

    abrirOcorrencia() {
      this.$http
          .post("/ocorrencia/problema?id_local=" + this.idLocal + "&tipo_local=" + this.tipoLocal, this.problemas)
          .then((res) => {
            this.alertaMensager("", res.data, "success");
            this.$router.push("/bloco")
          });
    },

    alertaMensager(mensagem, titulo, tipo) {
      this.$fire({
        title: titulo,
        text: mensagem,
        type: tipo,
      }).then((r) => {
        r.value;
      });
    },
  }
};
</script>

<style>

</style>
